var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diaLog"},[_c('van-dialog',{attrs:{"title":"温馨提示","message":"确认取消订单吗？","cancel-button-text":"考虑一下","confirm-button-text":"不考虑了","close-on-click-overlay":true,"show-cancel-button":""},on:{"confirm":_vm.confirm},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }